import PlayButtonInverse from '../src/PlayButtonInverse';
export default PlayButtonInverse;
